import { EpiContent } from '@api/types';
import { BlockContainer, ContentArea, Html, Title } from '@components';
import { Box, styled } from '@mui/material';
import { breakpoints } from '@themes/theme.helpers';

// STYLES
//--------
const ColumnsWrapper = styled(Box)<ColumnsWrapperProps>`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(0, 1fr));
  gap: 0 40px;
  grid-template-columns: 1fr;
  margin: 0 auto;

  ${breakpoints.up('md')} {
    grid-template-columns: ${(props) => props.widthRatios || '100%'};
  }
`;

// TYPES
//-------
export type ColumnBlockProps = {
  title?: string;
  content?: EpiContent;
  width?: string;
  widthRatio?: string;
};

export type ColumnsWrapperProps = {
  widthRatios?: string;
};

// COMPONENTS
//------------
export const ColumnBlock = ({ title, content = [], width, widthRatio }: ColumnBlockProps) => {
  return (
    <BlockContainer>
      {title && (
        <Title color='black' sx={{ textAlign: 'center', marginBottom: 5 }}>
          {title}
        </Title>
      )}
      <ColumnsWrapper maxWidth={width} widthRatios={widthRatio}>
        <ContentArea
          content={content}
          wrapperComponent={(props) => <Html html={props.block.text} />}
        />
      </ColumnsWrapper>
    </BlockContainer>
  );
};
